'use client'

import dynamic from 'next/dynamic'
import { cn } from 'ui'

import { useEffect, useMemo, useState } from 'react'
import { PDFRendererProps } from './NativeRenderer'
import { PageContainer } from './PageContainer'

const Page = dynamic(() => import('./Page').then((mod) => mod.Page), {
  ssr: false,
})

export const ImageRenderer = ({
  children,
  onPageViewportIn,
  onPageBoundaryChange,
  onDocumentReady,
  pdf,
  zoom,
  headerHeight,
}: PDFRendererProps) => {
  const [pagesReady, setPagesReady] = useState<Record<number, boolean>>({})

  const isDocumentReady = useMemo(
    () => Object.keys(pagesReady).length >= Math.min(pdf.pages.length, 2),
    [pagesReady]
  )

  useEffect(() => {
    if (onDocumentReady && isDocumentReady) {
      onDocumentReady()
    }
  }, [isDocumentReady])

  return (
    <>
      {children}
      <PageContainer
        className={cn('ml-auto mr-auto opacity-0', {
          'opacity-100': isDocumentReady,
        })}
        style={{
          width: `${zoom * 100}%`,
        }}
      >
        {pdf.pages.map((page, index) => {
          return (
            <Page
              headerHeight={headerHeight}
              onPageBoundaryChange={onPageBoundaryChange}
              onPageViewportIn={onPageViewportIn}
              onDocumentReady={onDocumentReady}
              zoom={zoom}
              pdf={pdf}
              onLoad={() => {
                setPagesReady((prev) => ({
                  ...prev,
                  [index]: true,
                }))
              }}
              index={index}
              key={page.id}
              page={{
                ...page,
                page: index,
              }}
            />
          )
        })}
      </PageContainer>
    </>
  )
}
